import * as THREE from 'three';

export function createScene(): THREE.Scene {
    const scene = new THREE.Scene();

    scene.background = new THREE.Color(0x87ceeb);

    // fog color, start, end
    scene.fog = new THREE.Fog(0x87ceeb, 10, 100);

    return scene;
}
